module.exports = __webpack_public_path__ + "static/img/blog_new_2.07a3ef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/blog_new_2.png
// module id = gLoz
// module chunks = 8